var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.054334%",
    cy: "89.4932279%",
    fx: "52.054334%",
    fy: "89.4932279%",
    r: "88.3149751%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E31F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EEA9",
    offset: "58.9086294%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27BF88",
    offset: "86.5522981%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stud-mgmt-v3-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student_Management_profiledashboard2_v3",
    transform: "translate(-502.000000, -195.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(458.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 L12.5,0 C19.4035594,-1.26816328e-15 25,5.59644063 25,12.5 L25,12.5 C25,19.4035594 19.4035594,25 12.5,25 L12.5,25 C5.59644063,25 8.45442189e-16,19.4035594 0,12.5 L0,12.5 C-8.45442189e-16,5.59644063 5.59644063,1.26816328e-15 12.5,0 Z",
    id: "Rectangle",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(5.833333, 7.500000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3169405,0.199426269 C12.0728734,-0.0664754229 11.6771708,-0.0664754229 11.4330549,0.199426269 L3.94517341,8.35644869 L1.06695426,5.22105338 C0.822887179,4.95515169 0.427184537,4.95517829 0.183068624,5.22105338 C-0.0610228747,5.48692848 -0.0610228747,5.91798815 0.183068624,6.18388985 L3.50323059,9.80066348 C3.74722443,10.0665386 4.14322004,10.0663524 4.38711623,9.80066348 L12.3169405,1.16228933 C12.561032,0.89641423 12.5610076,0.46532796 12.3169405,0.199426269 Z",
    id: "Path"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryChecked);
export default __webpack_public_path__ + "static/media/summary_checked.ab814c9c0333e93c80de78278f46b232.svg";
export { ForwardRef as ReactComponent };